import { getDatabase, onValue, query, ref } from "firebase/database";
import { useEffect, useState } from "react";
export default function useWithdrawList(state) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [withdrawList, setWithdrawList] = useState([]);
  useEffect(() => {
    async function fetchUsers() {
      //databse related works
      const db = getDatabase();
      const jobRef = ref(db, "WithdrawSetting");
      const jobQuery = query(jobRef);
      try {
        setError(false);
        setLoading(true);
        //request firebase database;
        onValue(jobQuery, (snapshot) => {
          setLoading(false);
          if (snapshot.exists()) {
            setWithdrawList((prevCashout) => {
              return [...Object.values(snapshot.val())];
            });
          }
        });
      } catch (err) {
        setLoading(false);
        setError(true);
      }
    }
    fetchUsers();
  }, [state]);

  return { loading, error, withdrawList };
}
